import { render } from "./ContaVerificada.vue?vue&type=template&id=d15e477c&scoped=true"
import script from "./ContaVerificada.vue?vue&type=script&lang=js"
export * from "./ContaVerificada.vue?vue&type=script&lang=js"

import "./ContaVerificada.vue?vue&type=style&index=0&id=d15e477c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d15e477c"]])

export default __exports__